import { render, staticRenderFns } from "./WorldViewCreatePage.vue?vue&type=template&id=4b06d09b&scoped=true"
import script from "./WorldViewCreatePage.vue?vue&type=script&lang=ts"
export * from "./WorldViewCreatePage.vue?vue&type=script&lang=ts"
import style0 from "./WorldViewCreatePage.vue?vue&type=style&index=0&id=4b06d09b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b06d09b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b06d09b')) {
      api.createRecord('4b06d09b', component.options)
    } else {
      api.reload('4b06d09b', component.options)
    }
    module.hot.accept("./WorldViewCreatePage.vue?vue&type=template&id=4b06d09b&scoped=true", function () {
      api.rerender('4b06d09b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/WorldViewCreatePage.vue"
export default component.exports